import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-dotted-arrow-right",
  "use": "icon-s-dotted-arrow-right-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-dotted-arrow-right\"><path d=\"M8.76 11.838v-2h8.03l-6.275-6.274 1.323-1.323 7.274 7.274 1.322 1.323-8.596 8.596-1.323-1.323 6.274-6.273zm9-.97.03-.03-.03-.03zm-11.001.97h-2v-2h2zm-4 0h-2v-2h2z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol